import React from "react"
import { useNavigate } from "react-router-dom"

const Unauthorized = () => {
  const navigate = useNavigate()

  return (
    <div className="container mt-5">
      <div className="row justify-content-center">
        <div className="col-md-6 text-center">
          <div className="alert alert-danger">
            <h3>Access Denied</h3>
            <p>You are not authorized to view this page.</p>
            <button
              className="btn btn-primary mt-3"
              onClick={() => navigate("/")}
            >
              Go to Dashboard
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Unauthorized
